module.exports = __webpack_public_path__ + "388fb7bbcd5852fc437b58af474553e4.pdf";